import { Icon } from '@pandiafi/design-system'
import React from 'react'

import { ScreenReaderHint } from '../ScreenReaderHint/ScreenReaderHint'

export interface UserMenuButtonProps {
  expanded: boolean
  toggleUserMenu: () => void
  screenReaderHint: string
}

export const UserMenuButton = ({
  ref,
  expanded,
  toggleUserMenu,
  screenReaderHint,
}: UserMenuButtonProps & {
  ref?: React.RefObject<HTMLButtonElement | null>
}) => {
  return (
    <button
      ref={ref}
      type="button"
      aria-expanded={expanded}
      className="rounded-md p-2 text-primary"
      onClick={toggleUserMenu}
    >
      <ScreenReaderHint hint={screenReaderHint} />
      <Icon
        icon="user-circle"
        size="2x"
        className="text-primary w-9 fill-current"
      />
    </button>
  )
}
